import { CAccordionSummary } from "./AccordianStyle";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { MdExpandMore } from "react-icons/md";
import Modal from "../../Modal/Modal";
import { Accordion, AccordionDetails } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Column, Bold, Value } from "../../../style/Dashboard";
import React, { useState } from "react";
import UpArrow from "../../../assets/AssetArrow.png";
import "./Accordian.css";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontWeight: "500",
    color: "#4678ED",
    fontSize: "15px",
    marginLeft: "0px",
    padding: "0px !important",
    marginTop: "5px",
    marginBottom: "5px",
    fontFamily: "work sans !important",
    border: "30px",
  },
  AccordionD: {
    display: "unset !important",
    padding: "0 !important",
    backgroundColor: "#ffffff !important",
  },
  content: {
    backgroundColor: "#ffffff",
  },
}));

const Heading = [
  "Medication Orders",
  "PDMP Report",
  "Documentation",
  "Patient Education",
];

const PendingMedizenChart = [
  {
    "Patient Name": "Phil Belford",
    "Rx Name": "Medizen",
    "Rx Dose": "50",
    "Rx Frequency": "50",
    Duration: "3 months",
    "Order Status": "New",
    Provider: "Seinfeld",
  },
  // Add more rows as needed
];

const PendingPrimeraChart = [
  {
    "Patient Name": "Jane Doe",
    "Rx Name": "Primera",
    "Rx Dose": "10",
    "Rx Frequency": "10",
    Duration: "6 months",
    "Order Status": "Dispensed",
    Provider: "Alexander",
  },
  // Add more rows as needed
];

const MedizenFormDetails = {
  medicationName: "Medizen",
  amount: "NA",
  dosageForm: "Tablet",
  route: "orally",
  frequency: "Twice a day",
  patientDirection: `Day 1: Start with 2 tablets stat
  Day 2 onwards: Take 1 tablet orally 2 times a day`,
  daysSupply: "30",
  dispenseAmount: "50 Tablet",
  pharmacyNote: "60mg/day, 2 tab/day only",
  alternativeMedication: "Plavix MG Oral Tablet",
  imageHeader: "Ads/Horizontal1.jpeg",
  imageLeft: "Ads/Vertical1.jpeg",
  discount: true,
  price: "9.33",
  "Order Status": "New",
};

const PrimeraFormDetails = {
  medicationName: "Primera",
  amount: "NA",
  dosageForm: "Injection",
  route: "Infusion",
  frequency: "Once a week",
  patientDirection:
    "To be taken post-meal before sleeping. Keep hard candies handy",
  daysSupply: "",
  dispenseAmount: "10 injections",
  pharmacyNote:
    "2.5 mg once weekly for 4 weeks, Continue to 5mg once weekly for at least 4 weeks",
  alternativeMedication: "NA",
  imageHeader: "Ads/Horizontal5.jpeg",
  imageLeft: "Ads/Vertical.jpeg",
  discount: true,
  price: "8.78",
  "Order Status": "Dispensed",
};

const CombinedMedicineData = [...PendingMedizenChart, ...PendingPrimeraChart];

export default function NewAccordion(props) {
  const classes = useStyles();
  const [openHeading, setHeading] = useState("panel-0");
  var panel = 0;
  const history = useHistory();

 
  const handleClick = (value, row) => {
    console.log("rowwwwwwwwww", row["Order Status"]);

    // if(value === "Phil Belford")
    if (row["Order Status"] === "New") {
      window.sessionStorage.setItem(
        "medication",
        JSON.stringify(MedizenFormDetails)
      );
      history.push("/Pmc/pendingrx");
    } else {
      // window.sessionStorage.setItem('medication', JSON.stringify(PrimeraFormDetails));
    }
  };
  

  function generateWeekAccordion() {
    return Heading.map((head) => (
      <>
        <Accordion
          className={classes.heading}
          head={openHeading}
          expanded={openHeading === "panel-" + panel++}
          //onClick={() => handleAccordClick(head)}
          key={head}
          style={{ padding: "0px" }}
        >
          <CAccordionSummary
            className={classes.Accordion}
            expandIcon={
              <img
                src={UpArrow}
                style={{
                  marginLeft: "auto",
                  marginTop: "0px",
                  width: "13.5px",
                }}
              />
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>
              {" "}
              {head}
              <span style={{ float: "right" }}> {<Modal />}</span>
            </Typography>
          </CAccordionSummary>
          <AccordionDetails
            style={{ backgroundColor: "#ffffff" }}
            className={classes.AccordionD}
          >
            {" "}
            <Container
              style={{ backgroundColor: "#ffffff", padding: "10px 15px", fontFamily: "work sans" }}
            >
              <table
                className="customeTable pmc-dashboard-table"
                style={{ width: " 100%", color: "#58595B", fontSize: "14px", fontFamily: "work sans" }}
              >
                <thead>
                  <tr style={{ fontWeight: "500", fontFamily: "work sans" }}>
                    <td>Patient Name</td>
                    <td style={{ textAlign: "center" }}>Rx Name</td>
                    <td style={{ textAlign: "center" }}>Rx Dose</td>
                    <td style={{ textAlign: "center" }}>Rx Frequency</td>
                    <td style={{ textAlign: "center" }}>Duration</td>
                    <td style={{ textAlign: "center" }}>Orders Status</td>
                    <td style={{ textAlign: "center" }}>Provider</td>
                  </tr>
                </thead>
                <tbody>
                  {CombinedMedicineData.map((row, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          width: "150px",
                          color: "#4678ED",
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontFamily: "work sans",
                        }}
                        onClick={() => handleClick(row["Patient Name"], row)}
                      >
                        {row["Patient Name"]}
                      </td>
                      <td style={{ textAlign: "center" }}>{row["Rx Name"]}</td>
                      <td style={{ textAlign: "center" }}>{row["Rx Dose"]}</td>
                      <td style={{ textAlign: "center" }}>
                        {row["Rx Frequency"]}
                      </td>
                      <td style={{ textAlign: "center" }}>{row["Duration"]}</td>
                      <td style={{ textAlign: "center" }}>
                        {row["Order Status"]}
                      </td>
                      <td style={{ textAlign: "center" }}>{row["Provider"]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Container>
          </AccordionDetails>
        </Accordion>
        
        {/* {isDispensed && <DispensedPopup onClose={closeDispensedPopupHandler} />} */}
      </>
    ));
  }

  function handleAccordClick(head) {
    if (openHeading === head) setHeading("");
    if (openHeading !== head) setHeading(head);
  }

  return <div className="App">{generateWeekAccordion()}</div>;
}
